module.exports = require('./helpers/bundle-url').getBundleURL('fsYD4') + "logo.c51670a8.svg";